import EntityCrudPage from '../../shared/EntityCrudPage';
import { dataInformationConfig } from '../../config/entityConfigs';

const DataInformationPage = () => <EntityCrudPage config={dataInformationConfig} />;

export default DataInformationPage;
